import React from 'react';
import { motion } from 'framer-motion';

export default function TermsOfUse() {
  React.useEffect(() => {
    document.title = "Soon. — Terms of Use";
  }, []);

  return (
    <motion.article 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="max-w-3xl mx-auto w-full py-8 md:py-16"
    >
      <header className="mb-16">
        <h1 className="font-serif italic text-4xl md:text-5xl text-brand-cream mb-4">Terms of Use for Soon.</h1>
        <p className="font-mono uppercase tracking-[0.15em] text-sm text-brand-dim">Last updated: 24 June 2026</p>
      </header>

      <div className="prose-custom">
        <p>
          These terms govern your use of the Soon. mobile app ("the app"), published by Sussex Endocrine Clinic ("we", "us"). By downloading or using the app, you agree to these terms. If you do not agree, please do not use the app.
        </p>

        <h2>Your licence to use the app</h2>
        <p>
          We grant you a personal, non-exclusive, non-transferable, revocable licence to install and use the app on devices you own or control, for your own personal, non-commercial use. You may not copy, modify, reverse engineer, redistribute, or resell the app except where permitted by law.
        </p>

        <h2>App store terms</h2>
        <p>
          Your use of the app is also subject to the rules of the store you downloaded it from (the Apple App Store or Google Play). Where those store terms conflict with these terms for matters the store controls, the store terms apply.
        </p>

        <h2>Your content and your data</h2>
        <p>
          The countdowns, dates, and settings you create are stored only on your device. We do not have access to them. You are responsible for your own data, including keeping your own backups. We are not responsible for any loss of data, for example if you delete the app, lose your device, or reset it.
        </p>

        <h2>Acceptable use</h2>
        <p>
          You agree to use the app lawfully and not to misuse it, interfere with its normal operation, or attempt to access it in any way other than through the interface we provide.
        </p>

        <h2>The app is provided "as is"</h2>
        <p>
          The app is provided on an "as is" and "as available" basis. To the fullest extent permitted by law, we make no warranties of any kind, whether express or implied, including that the app will be uninterrupted, error free, or fit for a particular purpose. Countdown times and reminders are provided for convenience and should not be relied on for time-critical, medical, legal, or safety purposes.
        </p>

        <h2>Limitation of liability</h2>
        <p>
          To the fullest extent permitted by law, we will not be liable for any indirect, incidental, or consequential loss, or for any loss of data, arising from your use of or inability to use the app. Nothing in these terms limits any liability that cannot be limited under applicable law, including your statutory rights as a consumer.
        </p>

        <h2>Price</h2>
        <p>
          The app is free to use. Every feature is included. There are no subscriptions or in-app purchases.
        </p>

        <h2>Changes to the app and these terms</h2>
        <p>
          We may update the app and these terms from time to time. The current version of these terms will always be posted at this address with the date it took effect. Continued use of the app after changes means you accept the updated terms.
        </p>

        <h2>Ending your use</h2>
        <p>
          You can stop using the app at any time by deleting it. We may suspend or withdraw the app, in whole or in part, where we reasonably need to.
        </p>

        <h2>Governing law</h2>
        <p>
          These terms are governed by the laws of England and Wales, and the courts of England and Wales have non-exclusive jurisdiction over any dispute.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about these terms can be sent to <a href="mailto:sussexendocrineclinic@gmail.com">sussexendocrineclinic@gmail.com</a>.
        </p>
      </div>
    </motion.article>
  );
}